import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { useDispatch } from "react-redux";
import { InsUploadButton } from "../common/insUploadButton";
import { getExcelRows } from "common/excel-helper";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { useCustomImportCustomPmis } from "hooks/administration/use-get-pmi-prices";
import { language } from "language/default";
import { setValidationMessage } from "store/administration/cashflow-forecasting/model-editing";
import { setMessagesDialog } from "store/messages-dialog";
const checkIsDuplicate = (cellValue, rowNo, map, result, setError) => {
    if ((cellValue?.toString() ?? "").trim() !== "") {
        if (map[cellValue]) {
            result.push(setError(rowNo));
            return true;
        }
        map[cellValue] = 1;
    }
    return false;
};
const checkIsMissing = (cellValue, rowNo, result, setError) => {
    if ((cellValue?.toString() ?? "").trim() === "") {
        result.push(setError(rowNo));
        return true;
    }
    return false;
};
const validatePmiFile = (indiceRows, priceRows) => {
    const errorsList = language.en.administration.marketDataAdministration.indices.importValidationErrors;
    if (indiceRows.length <= 0) {
        return [errorsList.emptyFileOrNoIndex];
    }
    const corectPrices = [], indexMap = {}, result = [], tickerMap = {};
    let duplicateIndex = false, duplicatePriceData = false, duplicateTicker = false, missingCurrency = false, missingIndex = false, missingPriceData = false, missingTicker = false, noIndexOnOneOfSheets = false;
    indiceRows.forEach((row, i) => {
        if (!missingIndex) {
            missingIndex = checkIsMissing(row.INDEX, i + 2, result, errorsList.missingIndex);
        }
        if (!missingTicker) {
            missingTicker = checkIsMissing(row.TICKER, i + 2, result, errorsList.missingTicker);
        }
        if (!missingCurrency) {
            missingCurrency = checkIsMissing(row.CURRENCY, i + 2, result, errorsList.missingCurrency);
        }
        const isDuplicate = checkIsDuplicate(row.INDEX, i + 2, indexMap, result, errorsList.duplicateIndex);
        duplicateIndex = duplicateIndex || isDuplicate;
        if (!duplicateTicker) {
            duplicateTicker = checkIsDuplicate(row.TICKER, i + 2, tickerMap, result, errorsList.duplicateTicker);
        }
    });
    priceRows.forEach((row, i) => {
        if (isNaN(row.PRICE ?? NaN) || (row.INDEX ?? "").trim() === "" || !(row.DATE instanceof Date) || isNaN(row.DATE.valueOf())) {
            if (!missingPriceData) {
                result.push(errorsList.missingPriceData(i + 2));
                missingPriceData = true;
            }
        }
        else if (!duplicatePriceData) {
            if (corectPrices.findIndex((x) => x.PRICE === row.PRICE && x.INDEX === row.INDEX && x.DATE.valueOf() === row.DATE.valueOf()) > -1) {
                result.push(errorsList.duplicatePriceData(i + 2));
                duplicatePriceData = true;
            }
            corectPrices.push(row);
        }
        if (!noIndexOnOneOfSheets && (row.INDEX ?? "").trim() !== "") {
            if (indexMap[row.INDEX]) {
                indexMap[row.INDEX] = 2;
            }
            else {
                noIndexOnOneOfSheets = true;
            }
        }
    });
    if (noIndexOnOneOfSheets || Object.values(indexMap).find((x) => x !== 2)) {
        result.push(errorsList.emptyFileOrNoIndex);
    }
    return result;
};
export const InsPublicEquityIndicesUpload = (props) => {
    const dispatch = useDispatch();
    const indicesLang = language.en.administration.marketDataAdministration.indices;
    let validationResult = [];
    const [, importIndices] = useCustomImportCustomPmis();
    const transform = (indiceRows, priceRows) => {
        validationResult = validatePmiFile(indiceRows, priceRows);
        if (validationResult.length > 0) {
            dispatch(setValidationMessage({ validationMessage: validationResult }));
            dispatch(setMessagesDialog({
                functionName: MessagesDialogFunctionName.Default,
                messages: validationResult.map((m) => Object({ message: m })),
                title: language.en.administration.marketDataAdministration.indices.importValidationErrors.dialogTitle,
                type: "alert"
            }));
        }
        else {
            const pmiPrices = {};
            indiceRows.forEach((r) => {
                pmiPrices[r.INDEX] = { currency: r.CURRENCY, customId: r.TICKER?.toString(), description: r.DESCRIPTION, name: r.INDEX, prices: [] };
            });
            priceRows.forEach((r) => pmiPrices[r.INDEX]?.prices?.push({ amount: r.PRICE, date: r.DATE }));
            importIndices(Object.values(pmiPrices), {});
            props.callback();
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(InsUploadButton, { accept: ".xls,.xlsx", label: indicesLang.equityIndices.importIndices, buttonType: AuxButtonTypeEnum.SECONDARY, buttonSize: AuxButtonSizeEnum.SMALL, onChanged: async (e) => {
                if (e.detail.newValue.length) {
                    const [file] = e.detail.newValue;
                    if (file.isValid) {
                        const pmiRows = await getExcelRows(file);
                        const pricesRows = await getExcelRows(file, 1);
                        transform(pmiRows, pricesRows);
                    }
                }
            } }));
};
